import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { store } from "./store/store";
import { queryClient } from "./lib/query-client";
import App from "./App";
import "./index.css";
import Loader from "./components/loader";
import * as Sentry from "@sentry/react";
import { preventInspection } from "./lib/prevent-inspection";

const SHOW_REACT_QUERY_DEVTOOLS = false;

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: "https://1efd6c33b06e9a69149a66e1381ae0ae@o4508880844816384.ingest.de.sentry.io/4508880851828816",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

preventInspection();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Suspense
        fallback={
          <div className="flex justify-center items-center h-screen">
            <Loader />
          </div>
        }
      >
        <Provider store={store}>
          <App />
        </Provider>
      </Suspense>
    </QueryClientProvider>

    {SHOW_REACT_QUERY_DEVTOOLS && (
      <ReactQueryDevtools initialIsOpen={false} client={queryClient} />
    )}
  </React.StrictMode>
);
